import { render, staticRenderFns } from "./SavedKnowledgeList.vue?vue&type=template&id=4e22e368&"
import script from "./SavedKnowledgeList.vue?vue&type=script&lang=js&"
export * from "./SavedKnowledgeList.vue?vue&type=script&lang=js&"
import style0 from "./SavedKnowledgeList.vue?vue&type=style&index=0&id=4e22e368&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports